import { z } from 'zod'

/** Category used in multiple objects. */
export const Category = z.object({
    /** Category ID. */
    id: z.number().nonnegative(),

    /** Name of the category. */
    name: z.string().min(1),

    /** Priority of the category. */
    priority: z.number().positive(),
})

export type Category = z.infer<typeof Category>
